import { connect } from 'react-redux';
import CategoryTable from '../../components/dashboard/CategoryTable';

const mapStateToProps = state => ({
  data: state.dashboard.categories.blockedCategories,
  firstColumn: 'category',
  loading: state.dashboard.blocked_infoLoading,
  id: 'categoryTable',
});

export default connect(
  mapStateToProps,
  undefined
)(CategoryTable);
